import { IStyles } from '../models/app/IStyles';

export const STYLES: IStyles = {
	components: {
		app: {
			children: {
				wrapper: {

				},
			},
		},
	},
	theme: {
		base: {
			tabs: {
				children: {
					header: {
						display: 'flex',
						border: {
							bottom: {
								color: '#cccccc',
								style: 'solid',
								width: '1px',
							},
						},
						margin: {
							bottom: '10px',
						},
					},
					tabHeader: {
						padding: {
							right: '20px',
						},
						cursor: 'pointer',
						flex: {
							_value: '1',
						},
					},
					activeTabHeader: {
						font: {
							weight: 'bold',
						},
						color: '#1EA7FD',
						border: {
							bottom: {
								color: '#1EA7FD',
								style: 'solid',
							},
						},
					},
					tabHeaderIcon: {
						width: '16px',
						height: '16px',
						margin: {
							right: '5px',
							left: '5px',
						},
						verticalAlign: 'text-top',
					},
				},
			},
		},
	},
};